import IntlProvider, {
  useIntl,
} from './IntlProvider'

export default IntlProvider

export {
  useIntl,
}

export { default as FirstPaintGate } from './FirstPaintGate'
export { default as selectLocale } from './lib/selectLocale'
